import { PackageType } from "../assignments/assignment";
import { ProgressStatus } from "../general/homeAssignment";

export interface EditTrainingRecordQueryParams {
  UserPortalUid: string;
  PortalAssignmentUid?: string;
  search?: string;
  status?: string;
  type?: string;
  startDateFrom?: string;
  startDateTo?: string;
  complitionDateFrom?: string;
  complitionDateTo?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  sort?: string;
}

export interface EditTrainingRecordAttemptQueryParams {
  UserPortalUid: string;
  PortalAssignmentUid: string;
  recordId?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  sort?: string;
}

export interface GetSingleTrainingRecordInfoParams {
  recordId: string;
}

export interface GetSingleTrainingRecordInfoResult {
  UserAssignmentUid: string;
  recordStatus: RecordStatus;
  recordNo: number;
  UpdatedAt: Date;
  startDate: Date | null;
  completionDate: Date | null;
  progressStatus: ProgressStatus;
  scores: string;
  attempts: string;
  timeSpent: number;
  reset: Boolean;
  packageType: PackageType;
}

export interface EditTrainingRecordBody {
  progressStatus: ProgressStatus;
  startDate?: string;
  completionDate?: string;
  scores?: string;
  maxAttempts?: number;
}

export interface GetTrainingRecordsPaginatedResult {
  count: number;
  previousPage: string;
  nextPage: string;
  rows: GetTrainingRecordResult[];
}

export enum RecordStatus {
  ACTIVE = "Active",
  INACTIVE = "Inactive",
}

export interface UserAssignmentAllTrainingRecords {
  UserAssignmentUid: string;
  recordStatus: RecordStatus;
  recordNo: number;
  UpdatedAt: Date;
  startDate: Date | null;
  completionDate: Date | null;
  progressStatus: ProgressStatus;
  scores: string;
  attempts: string;
  timeSpent: number;
  reset: boolean;
}

export interface UserAssignmentAllTrainingRecordsPaginatedResult {
  count: number;
  previousPage: string;
  nextPage: string;
  rows: UserAssignmentAllTrainingRecords[];
}

export interface GetTrainingRecordResult {
  UserAssignmentUid: string;
  PortalAssignmentUid?: string;
  completionDate: string;
  score: string;
  startDate: string;
  status: string;
  title: string;
  type: string;
}
